/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import edit from "../../../../assets/images/action_edit.svg";
import download from "../../../../assets/images/action_download.svg";
import history from "../../../../assets/images/action_history.svg";
import historyActive from "../../../../assets/images/action_history_active.svg";
import notes from "../../../../assets/images/notes.svg";
import { Space, Popover, Tooltip, notification } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { handleDownload } from "views/pages/Invoice/utils";
import environment from "environment";


const Actions = ({ record, selectedHistory, handleSelectedHistory }) => {
  const { t } = useTranslation();
  const [showPopup] = useState(false);
  const navigate = useNavigate();
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);

    const options = {
      weekday: "short",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "Europe/Paris",
    };

    const formatter = new Intl.DateTimeFormat(t("currentLanguage"), options);
    const formattedDate = formatter.format(date);

    // Normal Code
    // return formattedDate.replace(/,/g, "");


    // Captialization code
    const capitalize = str => str
    .split(' ') 
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' '); 
    const capitalizedDate = capitalize(formattedDate.replace(/,/g, ""));
    return capitalizedDate;


  };

  const translateStatus = (status) => {
    return t(status);
  };

  const Popup = ({ documentId, data }) => {
    handleSelectedHistory(documentId);
    const sortedData = [...data].sort((a, b) =>
      b.modified_at_CET.localeCompare(a.modified_at_CET)
    );
    return (
      <div className="col-md-12 text-start vh-popover px-0 mt-8 horizontal-scrollbar">
        <div>
          <div className="history-header pb-0">
            <h1 className="dark-text fs14 mb-2 poppins-medium">
              {t("versionHistory")}
            </h1>
          </div>
          {sortedData.map((item, index) => (
            <div key={index} className="popup-item px-3 pt-1 pb-2">
              <div className="d-flex align-items-center">
                <div className="username pe-3">
                  <div className="fs12 poppins-medium dark-text text-lowercase text-truncate">
                    {item.modified_by}:
                  </div>
                  <div className="fs12 cell-gray">
                    {formatDate(item.modified_at_CET)}
                  </div>
                </div>{" "}
                <span
                  className={
                    item.document_status === "not-started-card fs11 status-width"
                      ? "not-started-card ms-2 fs11 status-width"
                      : `${item.document_status}-span grid-card-subtitle ms-2 fs11 status-width`
                  }
                >
                  {translateStatus(item.document_status)}
                </span>
                {item.status ? (
                  <span className="status-span ms-2 fs11">
                    {translateStatus(item.status)}
                  </span>
                ) : (
                  <span className="status-span ms-2 fs11">
                    {translateStatus("Updated")}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const handleOnDownload = async () => {
    await handleDownload(record.sas_document_link);
 
    if (environment.APP_ENVIRONMENT !== 'alabusTesting') {
      // Disabling download excel for alabus client
      if (record.sas_excel_link) {
        setTimeout(async () => {
          await handleDownload(record.sas_excel_link);
        }, 3000);
      }
    }
  };

  const handleEdit = () => {
    if (
      record.extraction_status === "invalid_file_format" ||
      record.extraction_status === "invalid_pet_invoice" ||
      record.extraction_status === "extraction_issue"
    ) {
      notification.error({ message: t("notAllowedToEdit") });
    } else {
      navigate(`/invoice/${record.id}`);
    }
  };

  const onClickPopOver = () => {
    handleSelectedHistory(null);
  };

  return (
    <>
      <Space size="middle">
        <a>
          <Tooltip title={t("edit")} placement="bottom">
            <img
              onClick={handleEdit}
              src={edit}
              alt="edit"
              className="cursor-pointer"
            />
          </Tooltip>
        </a>
        <Tooltip title={t("download")} placement="bottom">
          <img
            onClick={handleOnDownload}
            src={download}
            alt="download"
            className="cursor-pointer"
          />
        </Tooltip>
        <Popover
          content={
            record.version_history ? (
              <Popup documentId={record.id} data={record.version_history} />
            ) : (
              ""
            )
          }
          trigger="click"
          overlayClassName="ant-popover-history"
          placement="bottomRight"
          onOpenChange={onClickPopOver}
        >
          <a>
            <Tooltip title={t("viewHistory")} placement="bottom">
              <img
                className="position-relative cursor-pointer"
                src={`${
                  selectedHistory === record.id ? historyActive : history
                }`}
                alt="history"
              />
            </Tooltip>
          </a>
        </Popover>
        {record?.notes?.trim().length && (
          <Popover
            content={record.notes ? record.notes : t("no_content")}
            trigger="click"
            overlayClassName="action-notes-popover"
            placement="leftTop"
            rootClassName=""
          >
            <a>
              <Tooltip title={t("notes")} placement="bottom">
                <img src={notes} alt="notes" className="cursor-pointer" />
              </Tooltip>
            </a>
          </Popover>
        )}
      </Space>
      {showPopup && <Popup data={record.version_history} />}
    </>
  );
};

export default Actions;
